<template>
    <CadastroPadrao :cabecalho="state.cabecalho" :linhas="state.linhas" :url="state.url" :titulo="state.titulo"
        :limparInput="limparInput" :objeto="state.objetoAuxiliar" :lstObrigatorios="state.lstObrigatorios"
        :lstObrigatoriosLabel="state.lstObrigatoriosLabel">
        <template v-slot:ficha>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.id" disabled>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Tipo Atendimento Pai
                </label>
                <div class="col inp">
                    <!-- <input type="text" class="form-control" v-model="state.objetoAuxiliar.idTipoAtendimento" disabled> -->
                    <select class="form-select" v-model="state.objetoAuxiliar.idTipoAtendimento">
                        <option v-for="(l, index) in state.lstTiposAtendimento" :key="index" :value="l.id">
                            {{ l.descricao }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Descrição
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.descricao">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Ativo
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check" v-model="state.objetoAuxiliar.ativo">
                </div>
            </div>
        </template>
    </CadastroPadrao>
</template>

<script setup>
import api from '@/api/api';
import CadastroPadrao from '@/components/CadastroPadrao.vue';
import store from '@/store/store';
import { reactive, onMounted, computed } from 'vue';

const state = reactive({
    cabecalho: ['Código', "Descrição", "Ativo"],
    linhas: ['id', 'descricao', 'ativo'],
    lstTiposAtendimento: [],
    url: "SubTipoAtendimento",
    titulo: "Cadastro de SubTipo de Atendimento",
    objetoAuxiliar: {
        id: 0,
        ativo: true
    },
    lstObrigatorios: ['descricao', 'idTipoAtendimento'],
    lstObrigatoriosLabel: ['Descrição', 'Tipo de Atendimento'],
});

async function limparInput(pObj) {
    if (pObj) {
        state.objetoAuxiliar = pObj;
    } else {
        state.objetoAuxiliar = {
            id: 0,
            ativo: true
        };
    }
}

onMounted(async () => {
    await api.TipoAtendimentoListar()
        .then(resp => {
            state.lstTiposAtendimento = resp;
            // console.log(resp);
        });
});
</script>

<style scoped>
.lbl {
    max-width: 35%;
    line-height: 35px;
}
</style>